import Theme1 from './theme1';

class DetailsList {
  constructor(props) {
    const { wrapper, ...params } = props;
    this.wrapper = wrapper;
    this.params = {
      ...params
    };

    this._init();
  }
  _init() {
    this._createTheme1();
  }
  _createTheme1() {
    const { data, onDetailsClick } = this.params;
    this.detailsList = new Theme1({
      data: data,
      wrapper: this.wrapper,
      onDetailsClick
    });
  }
  // changeSceneByName(name) {
  //   this.sceneList.changeSceneByName(name);
  // }
  show() {
    this.detailsList.show();
  }
  hide() {
    this.detailsList.hide();
  }
  toggle() {
    this.detailsList.toggle();
  }
}

export default DetailsList;
